<template>
	<div>
		<promo-sales-timed>
			<template slot-scope="{ phasesInfo: { currentPhase, annualSalesPhases, timeZone } }">
				<promo-sale-reminder-modal
					v-if="currentPhase == 0"
					:current-phase="currentPhase"
					:phases="annualSalesPhases"
					:time-zone="timeZone"
				/>
			</template>
		</promo-sales-timed>
	</div>
</template>

<script>
import PromoSalesTimed from "@/components/promo-sales-timed";
import PromoSaleReminderModal from "./promo-sale-reminder-modal";

export default {
	name: "PromoSaleReminderModalContainer",
	components: {
		PromoSalesTimed,
		PromoSaleReminderModal
	}
};
</script>